/* global axios */
import ApiClient from '../ApiClient';

// Read-only operational history. The server applies the same account and
// conversation-visibility scope as the conversation itself.
class ConversationTimelineAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  baseUrl() {
    return `${super.baseUrl()}/teletel`;
  }

  getTimeline(conversationId) {
    return axios.get(`${this.url}/${conversationId}/timeline`);
  }
}

export default new ConversationTimelineAPI();
